import "./Home.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Import images
import p1 from "./images/IMG_0495.jpeg";
import p3 from "./images/New_Years_Party_photo_20260101_Time-010193_ra9x1k.jpeg";
import p4 from "./images/New_Years_Party_photo_20260101_Time-020126_1zbusq.jpeg";
import p5 from "./images/1.jpg";
import p6 from "./images/2.jpeg";
import p7 from "./images/3.jpeg";
import p8 from "./images/4.jpeg";
import p9 from "./images/5.jpeg";
import p10 from "./images/2 (2).jpeg";
import p11 from "./images/3 (2).jpeg";
import p12 from "./images/4 (2).jpeg";
import p13 from "./images/5 (2).jpeg";
import p14 from "./images/Amazing Fitness Group Shot.jpg";
import p15 from "./images/Essential_April_Reset_Wellness_Retreat_0009_photo.jpeg";
import p16 from "./images/Essential_April_Reset_Wellness_Retreat_0038_photo (1).jpeg";
import p17 from "./images/Essential_April_Reset_Wellness_Retreat_0034_photo (1).jpeg";
import p18 from "./images/Sip_N_Savour_Annual_Ladies_Night_0019_photo.jpeg";
import p19 from "./images/Sip_N_Savour_Annual_Ladies_Night_0026_photo.jpeg";
import p20 from "./images/Sip_N_Savour_Annual_Ladies_Night_0082_photo.jpeg";
import p21 from "./images/1_Jake_Teya.jpg";
import p22 from "./images/2_Jake_Teya.jpg";
import p23 from "./images/3_Jake_Teya.jpg";
import p24 from "./images/4_Jake_Teya.jpg";
import p25 from "./images/5_Jake_Teya.jpg";
import p26 from "./images/6_Jake_Teya.jpg";
import p27 from "./images/7_Jake_Teya.jpg";
import p28 from "./images/8_Jake_Teya.jpg";
import p29 from "./images/9_Jake_Teya.jpg";
import p30 from "./images/10_Jake_Teya.jpg";
import p31 from "./images/11_Jake_Teya.jpg";
import p32 from "./images/12_Jake_Teya.jpg";
import p33 from "./images/13_Jake_Teya.jpg";

const Home = () => {
  const navigate = useNavigate();

  const galleryImages = [p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14, p15, p16, p17, p18, p19, p20, p21, p22, p23, p24,
    p25, p26, p27, p28, p29, p30, p31, p32, p33
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  // Close modal on ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setSelectedImage(null);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">The Party Parlour</h1>
            <p className="hero-subtitle">
              Premium portable photo booth experiences that capture every moment with style and sophistication.
            </p>
            <p className="hero-description">
              From intimate gatherings to grand celebrations, we bring professional photography services directly to your event.
            </p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={() => navigate("/Prices")}>
                View Packages
              </button>
              <button className="btn-secondary" onClick={() => navigate("/Contact")}>
                Get a Quote
              </button>
            </div>
          </div>

          <div className="hero-image-frame">
            <div className="image-frame">
              <img src={p1} alt="Photo booth experience" className="hero-image" />
              <div className="frame-decoration"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="section-header">
          <h2>Our Work</h2>
          <p>Capturing moments that matter</p>
        </div>

        <div className="gallery-grid">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className="gallery-item clickable"
              onClick={() => setSelectedImage(img)}
            >
              <div className="gallery-frame">
                <img src={img} alt={`Event ${index + 1}`} className="gallery-image" />
                <div className="frame-overlay"></div>
              </div>
            </div>
          ))}

          {/* Placeholders */}
          <div className="gallery-item placeholder">
            <div className="gallery-frame placeholder-frame">
              <div className="placeholder-content">
                <span className="placeholder-icon">📷</span>
                <span className="placeholder-text">More Photos Coming Soon</span>
              </div>
            </div>
          </div>

          <div className="gallery-item placeholder">
            <div className="gallery-frame placeholder-frame">
              <div className="placeholder-content">
                <span className="placeholder-icon">📷</span>
                <span className="placeholder-text">More Photos Coming Soon</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox-overlay" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setSelectedImage(null)}>
              ×
            </button>
            <img src={selectedImage} alt="Expanded view" />
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Make Your Event Unforgettable?</h2>
          <p>Let's discuss how we can bring the perfect photo booth experience to your celebration.</p>
          <button className="btn-primary large" onClick={() => navigate("/Contact")}>
            Book Your Event
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
